module.exports = __webpack_public_path__ + "static/media/BudgetPage.6fe50181.png";